import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Button as CustomButton } from '../../../../shared/components/ui/Button';

interface LockerCreateReservationActionsProps {
  isSubmitting: boolean;
  mode: 'create' | 'edit';
  onCancel?: () => void;
}

export function LockerCreateReservationActions({ 
  isSubmitting, 
  mode, 
  onCancel 
}: LockerCreateReservationActionsProps) {
  const navigate = useNavigate();

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      navigate('/lockers');
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      gap: 2, 
      justifyContent: 'flex-end', 
      mt: 4, 
      pt: 3, 
      borderTop: '1px solid',
      borderColor: 'divider'
    }}>
      <Button
        variant="outlined"
        onClick={handleCancel}
        disabled={isSubmitting}
        sx={{ minWidth: 120 }}
      >
        Cancelar
      </Button>
      
      <CustomButton
        type="submit"
        variant="contained"
        loading={isSubmitting}
        disabled={isSubmitting}
        sx={{ minWidth: 120 }}
      >
        {mode === 'create' ? 'Criar Reserva' : 'Atualizar Reserva'}
      </CustomButton>
    </Box>
  );
} 